/* Attributes & Allergens Client barrel export */

import { AttributesAllergensClientMocked } from './attributesAllergensClientMocked';

// Re-export types
export * from './attributesAllergensTypes';

// No real backend exists yet - always use the in-code mocked client.
const attributesAllergensClient = new AttributesAllergensClientMocked();

export { attributesAllergensClient, AttributesAllergensClientMocked };
export type { IAttributesAllergensClient } from './IAttributesAllergensClient';
